export default __webpack_public_path__ + "static/media/IBMPlexSans-ExtraLight.24801205.woff";